import { Store } from "vuex";
import { ApiStatus } from "@/store/general.types";
import { ExcludedReasonState } from "./excluded-reason.types";
import { excludedReasonApi } from "@/api/excluded-reason.api";

export const excludedReasonActions = {
    async getExcludedReasons(store: Store<ExcludedReasonState>, projectId: number) {
        try {
            store.commit('GET_EXCLUDED_REASONS_MUTATION', ApiStatus.LOADING);

            const { data } = await excludedReasonApi.getExcludedReasons(projectId);
            store.commit('GET_EXCLUDED_REASONS_MUTATION', { data });
        } catch (error) {
            store.commit('GET_EXCLUDED_REASONS_MUTATION', { error });
        }
    }
}